// veh_type_info/VehTypeInfoGql.js
import { gql } from "@apollo/client";

const VEH_TYPE_INFO_LIST_PART = gql`
fragment VehTypeInfoListPart on VehTypeInfo {
    vehTypeId
    vehTypeName
    freshCargo
    cargoUnit
    loadCapa
    loadCapaText
    minLoad
    minTemp
    maxTemp
    rentType
    fontColor
    backColor
    regDate
    regUser
}
`;


export const LIST_VEH_TYPE_INFO = gql`
${VEH_TYPE_INFO_LIST_PART}
query ListVehTypeInfo {
    vehTypeInfoList {
        ...VehTypeInfoListPart
    }
}
`;

export const GET_VEH_TYPE_INFO = gql`
${VEH_TYPE_INFO_LIST_PART}
query GetVehTypeInfo($vehTypeId:String!) {
    vehTypeInfoItem(vehTypeId:$vehTypeId) {
        ...VehTypeInfoListPart
    }
}
`;

export const ADD_VEH_TYPE_INFO = gql`
mutation AddVehTypeInfo($vehTypeInfo:InputVehTypeInfoAdd!) {
	vehTypeInfoAdd(vehTypeInfo: $vehTypeInfo) {
		ok
		message
	}
}
`;

export const EDIT_VEH_TYPE_INFO = gql`
mutation EditVehTypeInfo($vehTypeInfo:InputVehTypeInfoEdit!) {
	vehTypeInfoEdit(vehTypeInfo: $vehTypeInfo) {
		ok
		message
	}
}
`;

export const REMOVE_VEH_TYPE_INFO = gql`
mutation RemoveVehTypeInfo($vehTypeInfo:InputVehTypeInfoRemove!) {
	vehTypeInfoRemove(vehTypeInfo: $vehTypeInfo) {
		ok
		message
	}
}
`;
